// Marcadores de pedidos (foto del articulo) y agrupado para los mapas de / y /potencial-customers
import { SuperClusterViewportAlgorithm, getPaddedViewport } from "@googlemaps/markerclusterer";

// A zoom bajo, la vista mas el margen da la vuelta al mundo. Google envuelve la longitud (-162º menos
// 200 px pasa a ser 163º) y SuperCluster lo lee como un cruce del antimeridiano: el mapa sale casi vacio.
// Si la vista con margen es mas ancha que el mundo a ese zoom, se agrupa el mundo entero (son pocos grupos).
export class AgrupadoViewport extends SuperClusterViewportAlgorithm {
  cluster({ map, mapCanvasProjection }) {
    const bounds = map.getBounds();
    const anchoMundoPx = 256 * Math.pow(2, map.getZoom());
    const anchoVistaPx = Math.abs(
      mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast()).x -
      mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest()).x
    );
    const vista = anchoVistaPx + 2 * this.viewportPadding >= anchoMundoPx
      ? [-180, -90, 180, 90]
      : getPaddedViewport(bounds, mapCanvasProjection, this.viewportPadding);
    return this.superCluster.getClusters(vista, Math.round(map.getZoom())).map((f) => this.transformCluster(f));
  }
}

const clusterIconUrls = [
  "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png",
  "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m2.png",
  "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m3.png",
  "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m5.png",
  "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m4.png",  
];

// A partir de cuantos pedidos el mapa usa el pin estandar en vez de la foto del articulo.
// Con el agrupado por viewport solo se pintan las fotos visibles, asi que el umbral queda muy alto;
// bajarlo a unos 3000 si en rangos grandes vuelve a costar moverse por el mapa
const MAX_MARCADORES_CON_IMAGEN = 50000;

export const renderer = {
  render: ({ count, position }) => {
    // Elegir icono según tamaño del cluster
    let index = 0;
    if (count < 10) {
      index = 0;
    } else if (count < 50) {
      index = 1;
    } else if (count < 100) {
      index = 2;
    } else if (count < 500) {
      index = 3;
    } else {
      index = 4;
    }    

    const sizeMap = [53, 56, 59, 62, 65];
    const size = sizeMap[index];
    const url = clusterIconUrls[index];

    return new google.maps.Marker({
      position,
      icon: {
        url,
        scaledSize: new google.maps.Size(size, size),
      },
      label: {
        text: String(count),
        color: "#fff",
        fontSize: "14px",
        fontWeight: "bold",
      },
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
    });
  },
};

const crearMarcador = (lat, lng, title, image) => {
  const marker = { position: { lat, lng }, title };

  if (image) {
    // Miniatura de Shopify: sufijo _80x80 antes de la extension (icono de 40px, 2x para retina)
    marker.icon = {
      url: image.replace(/(\.[a-z0-9]+)(\?|$)/i, "_80x80$1$2"),
      size: new google.maps.Size(40, 40),
      scaledSize: new google.maps.Size(40, 40),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(20, 40),
    };
  }

  return new google.maps.Marker(marker);
};

// Un google.maps.Marker por pedido de /map/orders (sin mapa: se anaden a un MarkerClusterer)
export const marcadoresPedidos = (orders) => {
  // Un marcador por pedido (icono del primer articulo, todos los SKU en el titulo):
  // uno por linea apilaba objetos casi en el mismo punto y multiplicaba lo que hay que pintar
  // Por encima de MAX_MARCADORES_CON_IMAGEN se usa el pin estandar de Google:
  // miles de iconos con foto es lo que hace que cueste moverse por el mapa
  const conImagen = orders.length <= MAX_MARCADORES_CON_IMAGEN;
  const marcadores = [];
  orders.forEach((order) => {
    const items = order.line_items.filter((item) => !item.draft && item.image);
    if (!items.length) return;

    const lat = parseFloat(order.shipping_address?.latitude);
    const lng = parseFloat(order.shipping_address?.longitude);
    if (isNaN(lat) || isNaN(lng)) return;

    marcadores.push(
      crearMarcador(lat, lng, order.name + "\n" + items.map((i) => i.sku).join("\n"), conImagen ? items[0].image : null)
    );
  });
  return marcadores;
};
